export default __webpack_public_path__ + "static/media/dilmun.284f049d.png";